// 数据看板-弹窗-暂无数据
<template>
  <div class="DkbDialogNoData">
    <img class="icon" src="/static/images/dkb/dialog/icon_cnull.png" alt="">
    <p class="text">暂无数据</p>
  </div>
</template>

<script>
  let vm

  export default {
    name: 'DkbDialogNoData',
    components: {
    },
    data () {
      return {
      }
    },
    created () {
      vm = this
   
    },
    mounted() {
      // console.log('route', this.$route)
    },
    computed: {
    },
    methods: {
    },
    watch: {
    }
  }
</script>

<style lang="scss">
.DkbDialogNoData {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .icon {
    width: 1.42rem;
  }
  .text{
    color: #18728e;
    font-size: 0.18rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DkbPage/DialogPage/NoData.vue